<template>
  <div class="row">
    <ProgressBar />
    <div class="col-md-10 col-md-offset-1">
      <Step1Category v-show="getActiveStep === 0" />
      <Step2Model v-show="getActiveStep === 1" />
      <Step3Color v-show="getActiveStep === 2" />
      <Step4Unit v-show="getActiveStep === 3" />
    </div>
    <div v-show="getActiveStep === 4" class="spare" id="spare">
      <div class="col-md-7 col-md-push-5">
        <SpareIllust :key="componentKey" />
      </div>
      <div class="col-md-5 col-md-pull-7">
        <SpareTable :key="componentKey" />
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/spare/partials/ProgressBar.vue';
import Step1Category from '@/components/spare/partials/Step1Category.vue';
import Step2Model from '@/components/spare/partials/Step2Model.vue';
import Step3Color from '@/components/spare/partials/Step3Color.vue';
import Step4Unit from '@/components/spare/partials/Step4Unit.vue';
import SpareTable from '@/components/spare/partials/SpareTable.vue';
import SpareIllust from '@/components/spare/partials/SpareIllust.vue';

import { mapGetters } from 'vuex';
import API from '@/services/api';

export default {
  name: 'spare',
  computed: {
    ...mapGetters(['getActiveStep']),
    componentKey: {
      get() {
        return this.$store.state.componentKey;
      },
    },
    brand: {
      get() {
        return this.$store.state.brand;
      },
    },
  },
  components: {
    ProgressBar,
    Step1Category,
    Step2Model,
    Step3Color,
    Step4Unit,
    SpareTable,
    SpareIllust,
  },
  created() {
    switch (
      this.CryptoJS.SHA256(location.host).toString(this.CryptoJS.enc.Hex)
    ) {
      case '8b1fdc44bdaf9d6b7bdfa8b474864cbc57467393be4468704626ebab5e3ffea8':
        if (
          location.pathname == '/spf-ktm-test/' ||
          location.pathname == '/ktm-original-ersatzteilsuche/'
        ) {
          this.$store.commit('setBrand', 'ktm');
        } else if (
          location.pathname == '/spf-hqv-test/' ||
          location.pathname == '/husqvarna-original-ersatzteilsuche/'
        ) {
          this.$store.commit('setBrand', 'husky');
        } else if (
          location.pathname == '/spf-gasgas-test/' ||
          location.pathname == '/gasgas-original-ersatzteilsuche/'
        ) {
          this.$store.commit('setBrand', 'gasgas');
        }
        this.$store.commit('setAvcNative', false);
        this.$store.commit('setAvcLive', false);
        break;
      case 'ea7142a14deaa72238e60efa362998df83a904e0ddf58b209114049014f29317':
        this.$store.commit('setBrand', 'ktm');
        this.$store.commit('setAvcLive', false);
        this.$store.commit('setAvcNative', true);
        this.$store.dispatch('setModelByCode'); // global selector for JTL
        break;
      case 'd6aeb77ce95636f42523c4a6b04817a89a4e3d6bd8823e5ff4d4577cd24ef81f':
        this.$store.commit('setBrand', 'husky');
        this.$store.commit('setAvcLive', false);
        this.$store.commit('setAvcNative', true);
        this.$store.dispatch('setModelByCode'); //  global selector for JTL
        break;
      case '5098747b62c4b507b58b65c75432d1648e654fb4a696113c653d1baf873ddeff':
        this.$store.commit('setBrand', 'yamaha');
        this.$store.commit('setAvcLive', true);
        this.$store.commit('setAvcNative', false);
        break;
      case 'd404d80e4e98c2529ddf51eec929755894669104f5211923c1abc7876a55c2ed':
        this.$store.commit('setBrand', 'yamaha');
        this.$store.commit('setAvcLive', true);
        this.$store.commit('setAvcNative', false);
        break;
      case 'b88d4bdd363194e32db42666bb8d9983cf6968f5385376a6c13776c1253ce68f':
        this.$store.commit('setBrand', 'kawasaki');
        this.$store.commit('setAvcLive', false);
        this.$store.commit('setAvcNative', true);
        break;
      case '6f28313ab0bacfb2f542b1fb704dd29cee9722671f54b1dbd64122708f7e221f':
        this.$store.commit('setBrand', 'honda');
        this.$store.commit('setAvcLive', true);
        this.$store.commit('setAvcNative', false);
        break;
      case '8e35a18f465f5ad5b965f0f114568615adeaef711ff9e826bcd3d73b579f2046':
        this.$store.commit('setBrand', 'suzuki');
        this.$store.commit('setAvcLive', false);
        this.$store.commit('setAvcNative', true);
        break;
      case '5659aeec7b712b0957e8617525d9ef55ae5dfe9e9f978cfffd45c5368d1dc804':
        this.$store.commit('setBrand', 'yamaha');
        this.$store.commit('setAvcLive', true);
        this.$store.commit('setAvcNative', false);
        break;
      case 'e15b947e97479f5e314af0fafc6dccb8a0d934918a980433823face81b108beb':
        this.$store.commit('setBrand', 'ktm');
        this.$store.commit('setAvcLive', false);
        this.$store.commit('setAvcNative', true);
        break;
      case '09869992125fcabf40575b5c6547522ce81f341049deb16ad20f7f760baca0d0':
        this.$store.commit('setBrand', 'kawasaki');
        this.$store.commit('setAvcLive', true);
        this.$store.commit('setAvcNative', false);
        break;
      case '894d7c730f41ac5d96696741617817405175ed34e14e4bec89f1fb0f098dd733':
        this.$store.commit('setBrand', 'kawasaki');
        this.$store.commit('setAvcLive', true);
        this.$store.commit('setAvcNative', false);
        break;
      case 'a805cbc43c3b4ca19750ac3b9a136b31383e176d9b91cab50f38491fcc10adce':
        this.$store.commit('setBrand', 'gasgas');
        this.$store.commit('setAvcLive', false);
        this.$store.commit('setAvcNative', true);
        break;
      case '487d1e9410d741e35e70dadfef14768cbde872d1a6bce3da129c28909c194b81':
        let newState = {
          componentKey: 0,

          brand: null,
          avcNative: null,
          avcLive: null,

          activeStep: 0,

          selectedCategory: null,
          selectedYear: null,
          selectedModel: null,
          selectedColor: null,
          selectedUnit: {},
          selectedUnitCategory: {},

          selectedPart: {} /* For PriceBox */,
          selectedPoint: {} /* For PriceBox */,
          selectedVIN: null,

          availableCategories: [],
          availableYears: [],
          availableModels: [],
          availableColors: [],
          availableUnits: [],
          availableFilteredUnits: [],
          availableUnitsCategories: [],

          parts: [],
          points: [],
        };
        this.$store.replaceState(newState);

        if (
          location.pathname == '/spf-ktm-test/' ||
          location.pathname == '/ktm-original-ersatzteilsuche/'
        ) {
          this.$store.commit('setBrand', 'ktm');
        } else if (
          location.pathname == '/spf-hqv-test/' ||
          location.pathname == '/husqvarna-original-ersatzteilsuche/'
        ) {
          this.$store.commit('setBrand', 'husky');
        } else if (
          location.pathname == '/spf-gasgas-test/' ||
          location.pathname == '/gasgas-original-ersatzteilsuche/'
        ) {
          this.$store.commit('setBrand', 'gasgas');
        }
        this.$store.commit('setAvcNative', false);
        this.$store.commit('setAvcLive', false);
        break;
    }

    API.get(`/index.php?action=getCategories&brand=${this.brand}`).then(
      (response) => {
        this.$store.commit('setCategories', response.data);
      }
    );
  },
};
</script>
